import {
  Users, Percent, Wallet, Trophy, Swords, Target, Calculator, CircleSlash, Medal, Layers, Crown, MessageCircle, KeyRound, Zap, ShieldCheck,
  Headphones, TrendingUp, Smartphone, Gift, BadgeCheck, Clock, Star, Flame, Gem, Coins, Dice5, Spade, Club, Heart, Diamond, Rocket, Award,
  Banknote, CreditCard, Globe, MapPin, Sparkles, ThumbsUp, Timer, Lock, Gamepad2, Tv, Calendar, CheckCircle2,
} from "lucide-react";

export const ICONS = {
  Users, Percent, Wallet, Trophy, Swords, Target, Calculator, CircleSlash, Medal, Layers, Crown, MessageCircle, KeyRound, Zap, ShieldCheck,
  Headphones, TrendingUp, Smartphone, Gift, BadgeCheck, Clock, Star, Flame, Gem, Coins, Dice5, Spade, Club, Heart, Diamond, Rocket, Award,
  Banknote, CreditCard, Globe, MapPin, Sparkles, ThumbsUp, Timer, Lock, Gamepad2, Tv, Calendar, CheckCircle2,
};

export const DynIcon = ({ name, fallback = "Star", ...p }) => {
  const I = ICONS[name] || ICONS[fallback];
  return <I {...p} />;
};
